"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMON_API_URLS = void 0;
var COMMON_API_URLS;
(function (COMMON_API_URLS) {
    COMMON_API_URLS["UPLOAD"] = "/v2/general/upload-file";
    COMMON_API_URLS["GET_BLOCKCHAINS"] = "/v2/general/get-blockchains";
    COMMON_API_URLS["GET_COINS"] = "/v2/general/get-coins";
    COMMON_API_URLS["GET_VERSION"] = "/v2/general/get-version";
    COMMON_API_URLS["GET_EXCHANGE_RATES"] = "/v2/general/get-exchange-rates";
})(COMMON_API_URLS = exports.COMMON_API_URLS || (exports.COMMON_API_URLS = {}));
